import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
  NgZone,
} from '@angular/core';
import {
  MatDialog as MatMaterialDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { Helper } from 'src/app/helper/defult';
import { AuthService } from 'src/app/services/auth.service';
import { HttpIOService } from 'src/app/services/http-io.service';
import { SavedjobComponent } from '../savedjob/savedjob.component';
import { SharejobComponent } from '../sharejob/sharejob.component';
import { Title } from '@angular/platform-browser';
import { Subject } from 'rxjs';
import { Observable, Subscription, interval } from 'rxjs';
import { SaveWithoutLoginComponent } from '../save-without-login/save-without-login.component';
import { AnonymousUserComponent } from '../anonymous-user/anonymous-user.component';
import { ViaEmailComponent } from '../via-email/via-email.component';
import { ViaExternalUrlComponent } from '../via-external-url/via-external-url.component';
import { ViaWorkNigeriaComponent } from '../via-work-nigeria/via-work-nigeria.component';
import { environment } from '../../../../environments/environment';
import { ReportJobComponent } from '../report-job/report-job.component';
import { DynamicSnacbarComponent } from 'src/app/container/elements/dynamic-snacbar/dynamic-snacbar.component';
import { DynamicSnacbarErrorComponent } from 'src/app/container/elements/dynamic-snacbar-error/dynamic-snacbar-error.component';
import { DynamicSnacbarSkipComponent } from 'src/app/container/elements/dynamic-snacbar-skip/dynamic-snacbar-skip.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { LegacyPageEvent as PageEvent } from '@angular/material/legacy-paginator';
import { EmployerService } from '../../../services/employer.service';
import { takeWhile, scan, tap } from 'rxjs/operators';
import { interval as observableInterval } from 'rxjs';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { DataService } from 'src/app/services/data.service';
import { CreateAlertComponent } from '../../jobseeker/create-alert/create-alert.component';
import { RestrictedJobViewModal } from 'src/app/modals/restricted-job-view-modal/restricted-job-view-modal.component';
import { PaginationService } from '../../../services/paginationService';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
  UntypedFormArray,
} from '@angular/forms';
import { DatePipe } from '@angular/common';
import { NgTinyUrlService } from 'ng-tiny-url';
import { RecruiterWantToJobSeekerSideComponent } from '../../general/recruiter-want-to-job-seeker-side/recruiter-want-to-job-seeker-side.component';

@Component({
  selector: 'app-search-ui',
  templateUrl: './search-ui.component.html',
  styleUrls: ['./search-ui.component.scss'],
})
export class SearchUiComponent implements OnInit {
  status: boolean = false;
  jobLists: any = [];
  totalNoJobs = 0;
  detailsOfJob: any;
  shareJobId: any = '';
  shareJobCollection: any;
  searchDipendency: any;
  xxxxx: boolean = false;
  userDeatils: any;
  companyData: any;
  filterData: any;
  collectionSize: number;
  refresh: Subject<any> = new Subject();
  payLoad: any = {};
  userIdByurl: any;
  collectionIdByurl: any;
  viewJobPayLoad: any = {};
  guestUserJobId: any;
  allHotJobs: any;
  showReportSection: boolean;
  JobsByCategory: any;
  nojob: boolean = false;
  redirectForGuestSelectJob: any;
  collectionRecords: any;
  LogoutStateSaveJob: any;
  showRightSectionInMobile: boolean = false;
  isExpriedButton: boolean = false;
  countOfApplied: any;
  title: any;
  appliedStatus: any;
  dateDiff: number;
  clickSection: any = '';
  eachJobCompanyDetails: any;
  allRelatedJob: any;
  searchPhrase = '';

  email?: string;
  createAlartForm: UntypedFormGroup;

  length = 100;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  pageEvent: PageEvent;

  sum = 50;
  throttle = 400;
  scrollDistance = 1;
  scrollUpDistance = 2;
  direction = '';
  startJobIndex: number = 0;
  jobAppliedButtonDisable: boolean = true;
  currentSectionagfeasgesrg: any = 'section1';

  jobDesc = '';
  qualifications = '';
  currentPage: number;

  pageSize = 5;
  showDesc: boolean = false;
  url: any;
  showLoading: boolean = true;

  employemntTypeList: any;
  jobCatagoryTypeList: any;

  expLvl = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];

  datePosted = [
    { name: 'Last Hour', value: 'lastHour' },
    { name: 'Last 24 Hours', value: 'past24hours' },
    { name: 'Last 7 Days', value: 'pastweek' },
    { name: 'Last 30 Days', value: 'pastMonth' },
  ];

  Salary = [
    100000, 200000, 300000, 400000, 500000, 600000, 700000, 800000, 900000,
    1000000,
  ];

  jobFilter: UntypedFormGroup;
  filtered: any = {};
  count: number = 0;
  searchText2Way: any = '';
  showingTextResult: any = '';
  location2Way: any = '';
  searchTextPattern = /^[A-Za-z0-9][A-Za-z0-9\s]*$/;

  email_title: any;
  jobLocation: any;
  record: any;
  pic: any;
  cityRecords: any;

  displayFilters = false;

  inDemand = [
    'Customer Service',
    'Executive Assistant',
    'Marketing Coordinator',
    'Legal Practitioner',
    'Receptionist',
    'Personal Assistant',
    'Data Analysis',
    'Product Manager',
    'HR generalist',
    'Sales Manager',
    'Consulting',
    'Adhoc staff required in Abuja',
    'Administrative Assistant',
    'Storekeeper',
    'Account Officer',
    'Social Media Manager',
  ];

  selectedInDemandJob: string = '';

  // Key for localStorage
  private readonly FILTER_STATE_KEY = 'jobSearchFilters';
  private readonly RETURN_URL_KEY = 'returnToSearchUrl';
  private isInitialLoad = true;
  private skipQueryParamUpdate = false;

  isScrolled = false;

  @HostListener('window:scroll', ['$event'])
  onWindowScroll() {
    const jobDescElement = document.querySelector('.job-desc-name');
    if (jobDescElement) {
      const scrollPosition =
        window.pageYOffset || document.documentElement.scrollTop;
      // Adjust this value based on when you want the sticky header to become compact
      this.isScrolled = scrollPosition > 100;

      if (this.isScrolled) {
        jobDescElement.classList.add('scrolled');
      } else {
        jobDescElement.classList.remove('scrolled');
      }
    }
  }

  constructor(
    private router: Router,
    private activeRoute: ActivatedRoute,
    private route: ActivatedRoute,
    private snackBar: MatSnackBar,
    private io: HttpIOService,
    private auth: AuthService,
    private helper: Helper,
    private dialog: MatDialog,
    private materialDialog: MatMaterialDialog,
    private titleService: Title,
    public loaderService: NgxSpinnerService,
    private EmployerService: EmployerService,
    private dataService: DataService,
    private zone: NgZone,
    private paginationService: PaginationService,
    private fb: UntypedFormBuilder,
    private tinyUrl: NgTinyUrlService
  ) {
    this.currentPage = this.paginationService.getCurrentPage();
    let localUser = localStorage.getItem('workNigeriaUser');
    let sessionUser = sessionStorage.getItem('workNigeriaUser');
    if (localUser) {
      this.userDeatils = JSON.parse(
        this.helper.fromBinary(atob(localStorage.getItem('workNigeriaUser')))
      );
      this.companyData = this.auth.getCurrentCompanyData();
    }
    if (sessionUser) {
      this.userDeatils = JSON.parse(
        this.helper.fromBinary(atob(sessionStorage.getItem('workNigeriaUser')))
      );
      this.companyData = this.auth.getCurrentCompanyDataInSessoin();
    }
    let guestUserByselected = sessionStorage.getItem('guestUserSelectedJob');
    if (guestUserByselected) {
      this.guestUserJobId = JSON.parse(
        atob(sessionStorage.getItem('guestUserSelectedJob'))
      );
    }

    this.activeRoute.queryParams.subscribe((event) => {
      this.shareJobId = event['id'];
      this.collectionIdByurl = event['collectionId'];
      this.userIdByurl = event['userId'];
      this.allHotJobs = event['job_type_Home'];
      this.JobsByCategory = event['job_type_Category'];
      this.redirectForGuestSelectJob = event['role'];
      this.title = event['title'];
    });

    this.io.getforjobCategory().subscribe((res) => {
      if (res != null) {
        this.filterData = res;
        this.apiJobSearch(this.filterData);
      }
    });

    this.EmployerService.getloadMoreInSearchJob().subscribe((res) => {
      if (res === 'loadJobInSearchPage') {
        // Load more logic
      }
    });
  }

  ngOnInit(): void {
    this.scrollToElement('topOfJobs');

    this.paginationService.currentPage$.subscribe((page) => {
      this.currentPage = page;
    });

    // Initialize form first
    this.validationForm();
    this.employmentType();
    this.cityList();
    this.jobCatagory();

    // Check if returning from login with saved state
    this.checkAndRestoreFilterState();

    // Load filters from query params if present (only on initial load)
    if (this.isInitialLoad) {
      this.loadFiltersFromQueryParams();
      this.isInitialLoad = false;
    }

    if (this.userDeatils) {
      this.getCollection();
      this.payLoad = {
        path: 'search-job',
        userId: this.userDeatils.id,
        size: 10,
        start: 0,
      };
    } else {
      this.payLoad = {
        path: 'search-job',
        size: 10,
        start: 0,
      };
    }

    // Only proceed with special searches if no query params are present
    const hasQueryParams = Object.keys(this.route.snapshot.queryParams).some(
      (key) =>
        [
          'searchText',
          'job_location',
          'created_at',
          'employment_type_id',
          'category_id',
          'minimum_experience',
          'minimum_salary',
        ].includes(key)
    );

    if (!hasQueryParams) {
      if (this.collectionIdByurl) {
        this.apiJobSearch({
          path: 'search-job',
          userId: this.userIdByurl,
          collectionId: this.collectionIdByurl,
        });
      } else if (this.shareJobId) {
        this.apiJobSearch({
          path: 'search-job',
          id: this.shareJobId,
        });
      } else if (this.allHotJobs) {
        this.apiJobSearch({
          path: 'search-job',
          job_type: String(this.allHotJobs),
        });
      } else if (this.JobsByCategory) {
        this.apiJobSearch({
          path: 'search-job',
          category_id: this.JobsByCategory,
        });
      } else if (!this.filterData) {
        this.apiJobSearch(this.payLoad);
      }
    }

    this.dataService.sharedData.subscribe((data) => (this.searchPhrase = data));

    this.io.getforjobCategory().subscribe((res) => {
      if (res != null) {
        this.searchText2Way =
          res?.searchText != ''
            ? res?.searchText
            : this.jobFilter.get('searchText').value;
        this.location2Way =
          res?.job_location != ''
            ? res?.job_location
            : this.jobFilter.get('job_location').value;
      }
    });

    // To trigger the last 7 days filter through email btn click
    if (this.route.snapshot.queryParams['filter'] && !hasQueryParams) {
      this.jobFilter.patchValue({
        created_at: this.route.snapshot.queryParams['filter'],
      });
      this.searchByDipendency();
    }
  }

  /**
   * Load filters from query params and update form
   */
  private loadFiltersFromQueryParams(): void {
    const params = this.route.snapshot.queryParams;

    if (Object.keys(params).length > 0) {
      const filterKeys = [
        'searchText',
        'job_location',
        'created_at',
        'employment_type_id',
        'category_id',
        'minimum_experience',
        'minimum_salary',
        'company_name',
        'only_3mtt',
      ];

      const filtersToApply: any = {};

      filterKeys.forEach((key) => {
        if (params[key]) {
          filtersToApply[key] = params[key];
        }
      });

      if (Object.keys(filtersToApply).length > 0) {
        // Set flag to skip query param update
        this.skipQueryParamUpdate = true;

        // Update form with query params
        this.jobFilter.patchValue(filtersToApply);

        // Update 2-way bound variables
        if (params['searchText']) {
          this.searchText2Way = params['searchText'];
        }
        if (params['job_location']) {
          this.location2Way = params['job_location'];
        }

        // Trigger search with loaded filters
        setTimeout(() => {
          this.searchByDipendency();
          // Reset flag after search is triggered
          setTimeout(() => {
            this.skipQueryParamUpdate = false;
          }, 100);
        }, 100);
      }
    }
  }

  /**
   * Update query params when filters change
   */
  private updateQueryParams(filters: any): void {
    // Skip if flag is set (when loading from query params)
    if (this.skipQueryParamUpdate) {
      return;
    }

    const queryParams: any = {};

    // Only add non-empty filter values to query params
    Object.keys(filters).forEach((key) => {
      if (
        filters[key] &&
        filters[key] !== '' &&
        key !== 'path' &&
        key !== 'userId' &&
        key !== 'size' &&
        key !== 'start' &&
        key !== 'startDate' &&
        key !== 'endDate'
      ) {
        queryParams[key] = filters[key];
      }
    });

    // Update URL without reloading
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: queryParams,
      queryParamsHandling: '',
      replaceUrl: true,
    });
  }

  /**
   * Save current state before login redirect
   */
  private saveFilterStateForLogin(): void {
    const currentUrl = this.router.url;
    localStorage.setItem(this.RETURN_URL_KEY, currentUrl);
  }

  /**
   * Check and restore filter state after login
   */
  private checkAndRestoreFilterState(): void {
    const returnUrl = localStorage.getItem(this.RETURN_URL_KEY);

    if (returnUrl && this.userDeatils) {
      // User has logged in and we have a saved URL
      localStorage.removeItem(this.RETURN_URL_KEY);

      // Navigate to the saved URL (which includes query params)
      this.router.navigateByUrl(returnUrl);
    }
  }

  isAlertOn = false;

  toggleAlert() {
    this.isAlertOn = !this.isAlertOn;
    if (this.isAlertOn) {
      this.createAlert();
    }
  }

  toggleFilter() {
    this.displayFilters = !this.displayFilters;
  }

  openErrorDialog(): void {
    const dialogRef = this.materialDialog.open(RestrictedJobViewModal, {
      height: '520px',
      width: '500px',
      disableClose: true,
      autoFocus: false,
    });

    dialogRef.afterClosed().subscribe(() => {
      console.log('The dialog was closed');
    });
  }

  splitDescription() {
    const description = this.detailsOfJob?.description || '';
    const keyword = this.detectKeyword(description);

    if (keyword) {
      const parts = description.split(keyword);
      this.jobDesc = parts[0];
      this.qualifications = parts[1];
    } else {
      this.jobDesc = description;
      this.qualifications = '';
    }
  }

  detectKeyword(description: string): string | null {
    const possibleKeywords = [
      'Requirements:',
      'Requirement:',
      'Requirement',
      'Requirements',
      'Qualifications',
      'Qualifications:',
    ];
    for (const keyword of possibleKeywords) {
      if (description.includes(keyword)) {
        return keyword;
      }
    }
    return '';
  }

  scroll() {
    document.getElementById('qualifications').scroll(0, 0);
  }

  jobDetails(i, job) {
    this.scrollToElement('topOfDesc');
    this.showDesc = true;
    this.titleService.setTitle(job.title);
    this.showRightSectionInMobile = true;
    this.LogoutStateSaveJob = job;
    this.status = job.id;
    this.detailsOfJob = this.jobLists[i];
    this.splitDescription();
    this.jobExpried(this.detailsOfJob);
    this.getCompanyDetailsPerticularJob(this.detailsOfJob);
    this.relatedJob(this.detailsOfJob);
    this.reportJob();
    this.viewJob(job);
    this.copyLinkShare(job);
  }

  jobDetailsRelated(i, job) {
    this.showRightSectionInMobile = true;
    this.LogoutStateSaveJob = job;
    this.status = job.id;
    this.detailsOfJob = this.allRelatedJob[i];
    this.jobExpried(this.detailsOfJob);
    this.getCompanyDetailsPerticularJob(this.detailsOfJob);
    this.relatedJob(this.detailsOfJob);
    this.reportJob();
    this.viewJob(job);
    this.copyLinkShare(job);
  }

  viewJob(job) {
    if (this.userDeatils?.id == undefined || '') {
      this.viewJobPayLoad = {
        path: 'view-job',
        id: job.id,
      };
    } else {
      this.viewJobPayLoad = {
        path: 'view-job',
        id: job.id,
        userId: this.userDeatils?.id,
      };
    }
    this.io._viewJob(this.viewJobPayLoad).subscribe((res: any) => {
      if (res.serverResponse.code == 200) {
        this.countOfApplied = res['result'].applied;
      }
    });
  }

  onContainerScroll(event: any) {
    // Only run this logic if we are in mobile view/element is scrolling
    const element = event.target;
    const jobDescElement = document.querySelector('.job-desc-name');

    if (jobDescElement) {
      // Check scrollTop of the element, not the
      this.isScrolled = element.scrollTop > 50;

      if (this.isScrolled) {
        jobDescElement.classList.add('scrolled');
      } else {
        jobDescElement.classList.remove('scrolled');
      }
    }
  }

  jobExpried(job) {
    this.appliedStatus = '';
    if (job.expired_at) {
      this.dateDiff = this.helper.calculateDiff(
        new Date(job.expired_at),
        new Date()
      );
      if (this.dateDiff >= 0) {
        this.isExpriedButton = false;
      } else {
        this.isExpriedButton = true;
      }
    }
    if (this.userDeatils) {
      if (this.userDeatils.userType == 'employer') {
        if (this.companyData.id == job.company_id) {
          this.jobAppliedButtonDisable = false;
        }
      }
    }
  }

  mobileViewClassClose() {
    this.showRightSectionInMobile = false;
    this.detailsOfJob = null;
  }

  eventExpireIn(eventDt: string | number | Date) {
    const currentDate = new Date();
    const eventDate = new Date(eventDt);

    const timeDiff = Math.abs(currentDate.getTime() - eventDate.getTime());
    const hoursDiff = Math.floor(timeDiff / (1000 * 60 * 60));

    if (hoursDiff < 24) {
      if (hoursDiff === 0) {
        const minutesDiff = Math.floor(timeDiff / (1000 * 60));
        return `Posted ${minutesDiff}m`;
      } else {
        return `Posted ${hoursDiff}h`;
      }
    } else {
      const daysDiff = Math.floor(hoursDiff / 24);
      if (daysDiff === 1) {
        return `Posted ${daysDiff} day`;
      } else {
        return `Posted ${daysDiff} days`;
      }
    }
  }

  onSectionChange(sectionId: any) {
    this.clickSection = sectionId;
  }

  scrollToElement(id: any) {
    this.clickSection = id;
    setTimeout(() => {
      const element = <HTMLElement>document.querySelector(`#${id}`);
      element.scrollIntoView({ behavior: 'smooth' });
    });
  }

  async scrollToHead() {
    await window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }

  swipeRelatedJobs() {
    window.scrollTo({ top: 0, behavior: 'smooth' });

    const relatedSection = document.querySelector('#related');
    if (relatedSection) {
      relatedSection.scrollIntoView({ behavior: 'smooth' });

      const firstCard = relatedSection.querySelector('.card-grid');
      if (firstCard) {
        firstCard.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }

  async onScrollJobChange(id: any) {
    this.clickSection = id;
    if (window.innerWidth > 570) {
      setTimeout(() => {
        this.scrollToHead();
      }, 500);
      this.swipeRelatedJobs();
    }
    const element = <HTMLElement>document.querySelector(`#${id}`);
    element.scrollIntoView({ behavior: 'smooth' });
  }

  onScrollDown() {
    this.startJobIndex = this.startJobIndex + 10;
    if (
      !this.shareJobId &&
      !this.collectionIdByurl &&
      !this.filterData &&
      !this.allHotJobs &&
      !this.JobsByCategory
    ) {
      this.payLoad.start = this.startJobIndex;
      this.io
        .apicall(this.payLoad, 'jobsearch/search-job')
        .subscribe((res: any) => {
          if (res.serverResponse.code == 200) {
            let data = res['result'].jobList;
            this.totalNoJobs = res['pagination']?.total;
            this.jobLists.push(...data);
          }
        });
    } else {
      this.filterData.start = this.startJobIndex;
      this.io
        .apicall(this.filterData, 'jobsearch/search-job')
        .subscribe((res: any) => {
          if (res.serverResponse.code == 200) {
            let data = res['result'].jobList;
            this.totalNoJobs = res['pagination']?.total;
            this.jobLists.push(...data);
          }
        });
    }
    this.EmployerService.setloadMoreInSearchJob(null);
  }

  onPageChanged(pageNumber: number) {
    this.paginationService.setCurrentPage(pageNumber);
    this.startJobIndex = (pageNumber - 1) * this.pageSize;
    if (
      !this.shareJobId &&
      !this.collectionIdByurl &&
      !this.filterData &&
      !this.allHotJobs &&
      !this.JobsByCategory
    ) {
      this.payLoad.start = this.startJobIndex;
      this.io
        .apicall(this.payLoad, 'jobsearch/search-job')
        .subscribe((res: any) => {
          if (res.serverResponse.code == 200) {
            let data = res['result'].jobList;
            this.totalNoJobs = res['pagination']?.total;
            this.jobLists = data;
          }
        });
    } else {
      this.filterData.start = this.startJobIndex;
      this.io
        .apicall(this.filterData, 'jobsearch/search-job')
        .subscribe((res: any) => {
          if (res.serverResponse.code == 200) {
            let data = res['result'].jobList;
            this.totalNoJobs = res['pagination']?.total;
            this.jobLists = data;
          }
        });
    }
    this.EmployerService.setloadMoreInSearchJob(null);
  }

  scrollToTop(el) {
    const duration = 400;
    const interval = 5;
    const move = (el.scrollTop * interval) / duration;
    observableInterval(interval)
      .pipe(
        scan((acc, curr) => acc - move, el.scrollTop),
        tap((position) => (el.scrollTop = position)),
        takeWhile((val) => val > 0)
      )
      .subscribe();
  }

  savedJob(job) {
    if (this.userDeatils?.id == undefined || '') {
      // Save current state before redirecting to login
      this.saveFilterStateForLogin();

      const dialogRef = this.dialog.open(SaveWithoutLoginComponent, {
        height: 'auto',
        width: '450px',
        data: { Perticularjob: job, hint: 'logout-save-job' },
        autoFocus: false,
      });
      dialogRef.afterClosed().subscribe((res) => {
        if (res == 'save') {
          // Handle save
        }
      });
    } else {
      if (job.isSaved == true) {
        let jsonData = {
          path: 'unsaved-job',
          jobId: job.id,
          id: this.userDeatils.id,
        };
        this.io._unSaveJob(jsonData).subscribe((res: any) => {
          if (res.serverResponse.code == 200) {
            job.isSaved = false;
            this.snackBar
              .openFromComponent(DynamicSnacbarComponent, {
                data: res.serverResponse.message,
                verticalPosition: 'top',
                horizontalPosition: 'right',
              })
              .afterOpened()
              .subscribe(this.helper.setOnTop);
            if (this.filterData) {
              this.apiJobSearch(this.filterData);
            } else {
              this.apiJobSearch({
                path: 'search-job',
                userId: this.userDeatils.id,
              });
            }
          } else {
            this.snackBar
              .openFromComponent(DynamicSnacbarComponent, {
                data: res.serverResponse.message,
                verticalPosition: 'top',
                horizontalPosition: 'right',
              })
              .afterOpened()
              .subscribe(this.helper.setOnTop);
            if (this.filterData) {
              this.apiJobSearch(this.filterData);
            } else {
              this.apiJobSearch({
                path: 'search-job',
                userId: this.userDeatils.id,
              });
            }
          }
        });
      } else {
        const dialogRef = this.dialog.open(SavedjobComponent, {
          height: '90%',
          autoFocus: false,
          data: { data: job },
        });
        dialogRef.afterClosed().subscribe((res) => {
          job.isSaved = true;
          if (res == 'save') {
            if (this.filterData) {
              this.apiJobSearch(this.filterData);
            } else {
              this.apiJobSearch({
                path: 'search-job',
                userId: this.userDeatils.id,
              });
            }
          }
        });
      }
    }
  }

  getCollection() {
    let jsonData = {
      id: this.userDeatils?.id,
      path: 'collection-list',
    };
    this.io._getCollection(jsonData).subscribe((res: any) => {
      if (res.serverResponse.code == 200) {
        this.collectionRecords = res['result'].collectionList;
      }
    });
  }

  relatedJob(job) {
    let jsonData = {
      path: 'related-jobs',
      jobIds: [job.id],
      searchText: job.title,
      category_id: job.category_id,
    };
    this.io._relatedJob(jsonData).subscribe((res: any) => {
      if (res.serverResponse.code == 200) {
        if (res['result'].jobList.length > 0) {
          this.allRelatedJob = res['result'].jobList;
        }
      }
    });
  }

  apiJobSearch(data: any) {
    this.loaderService.show();
    this.io.apicall(data, 'jobsearch/search-job').subscribe((res: any) => {
      if (res.serverResponse.code == 200) {
        this.jobLists = res['result'].jobList;
        this.pageSize = this.pageSize - res['pagination']?.promotedJobs;
        this.collectionSize = res['pagination']?.total
          ? res['pagination']?.total
          : 0;
        this.totalNoJobs = res['pagination']?.total;
        this.startJobIndex = res['pagination']?.start;
        if (this.jobLists.length == 0) {
          this.nojob = true;
          this.detailsOfJob = null;
        }
        if (this.jobLists.length > 0) {
          this.viewJob(this.jobLists[0]);
          this.nojob = false;
          if (this.guestUserJobId) {
            const selectedIndex = this.jobLists.findIndex(
              (event) => event.id == this.guestUserJobId
            );
            const selectedJob =
              selectedIndex >= 0
                ? this.jobLists[selectedIndex]
                : this.jobLists[0];
            this.jobDetails(
              selectedIndex >= 0 ? selectedIndex : 0,
              selectedJob
            );
            this.loaderService.hide();
            let jsonData = {
              path: 'saved-job',
              jobId: selectedJob.id,
              id: this.userDeatils.id,
              collectionId: this.collectionRecords[0].id,
              jobProviderId: selectedJob.job_provider_id,
              title: selectedJob.title,
              jobSeekerName: `${this.userDeatils.firstName} ${this.userDeatils.lastName}`,
              companyId: selectedJob.company_id,
            };
            this.io._saveJob(jsonData).subscribe((res: any) => {
              if (res.serverResponse.code == 200) {
                sessionStorage.removeItem('guestUserSelectedJob');
                this.guestUserJobId = undefined;
                this.detailsOfJob.isSaved = true;
              }
            });
          } else if (this.redirectForGuestSelectJob) {
            const selectedIndex = this.jobLists.findIndex(
              (event) => event.id == this.guestUserJobId
            );
            const selectedJob =
              selectedIndex >= 0
                ? this.jobLists[selectedIndex]
                : this.jobLists[0];
            this.jobDetails(
              selectedIndex >= 0 ? selectedIndex : 0,
              selectedJob
            );
            this.loaderService.hide();
          } else {
            this.status = this.jobLists[0].id;
            this.loaderService.hide();
          }
          sessionStorage.removeItem('guestUserSelectedJob');
          this.reportJob();
        }
      } else {
        if (
          res.serverResponse.message ===
          '3MTT Jobs can only be viewed by registered 3MTT fellows'
        ) {
          this.openErrorDialog();
        }
        this.snackBar
          .openFromComponent(DynamicSnacbarErrorComponent, {
            data: res.serverResponse.message,
            verticalPosition: 'top',
            horizontalPosition: 'right',
            duration: 6000,
          })
          .afterOpened()
          .subscribe(this.helper.setOnTop);
      }
    });
  }

  getCompanyDetailsPerticularJob(job) {
    let jsonData = {
      path: 'get-company',
      company_id: job.company_id,
    };
    this.io._getCompanyDetails(jsonData).subscribe((res: any) => {
      if (res.serverResponse.code == 200) {
        this.eachJobCompanyDetails = res['result'].company;
      }
    });
  }

  draftJob(Perticularjob: any) {
    let jsonData = {
      path: 'draft-job',
      userId: this.userDeatils.id,
      jobId: Perticularjob.id,
      activityType: '',
    };
    if (Perticularjob.apply_via == '1') {
      jsonData.activityType = environment.activityType.via_workNigeria;
    } else if (Perticularjob.apply_via == '2') {
      jsonData.activityType = environment.activityType.via_url;
    } else if (Perticularjob.apply_via == '3') {
      jsonData.activityType = environment.activityType.via_email;
    }
    this.io._draftJob(jsonData).subscribe((res: any) => {
      if (res.serverResponse.code == 200) {
        // Handle draft success
      }
    });
  }

  async applyJob(Perticularjob: any) {
    if (Perticularjob.apply_via == '3') {
      const email_subject = `Application for the position: ${Perticularjob.title}`;
      const mailtoLink = `mailto:${Perticularjob.via_email}?subject=${encodeURIComponent(email_subject)}`;
      const anchor = document.createElement('a');
      anchor.href = mailtoLink;
      anchor.click();
      let jsonData = {
        path: 'apply-job-via-email',
        jobId: Perticularjob.id,
      };
      this.io._applyViaEmail(jsonData).subscribe((res: any) => {
        this.detailsOfJob.isApplied = true;
        this.detailsOfJob.applied_at = new Date();
      });
    } else {
      if (this.userDeatils?.id != undefined || '') {
        await this.draftJob(Perticularjob);
      }

      if (this.userDeatils?.id == undefined || '') {
        // Save current state before redirecting to login
        this.saveFilterStateForLogin();

        const dialogRef = this.dialog.open(AnonymousUserComponent, {
          height: '450px',
          width: '550px',
          autoFocus: false,
          data: { Perticularjob },
        });
        dialogRef.afterClosed().subscribe((res) => {
          if (res == 'save') {
            // Handle save
          }
        });
      } else {
        if (Perticularjob.apply_via == '2') {
          const dialogRef = this.dialog.open(ViaExternalUrlComponent, {
            height: '650px',
            width: '450px',
            data: { Perticularjob },
            autoFocus: false,
          });
          dialogRef.afterClosed().subscribe((res) => {
            if (res == 'save') {
              this.detailsOfJob.isApplied = true;
              this.detailsOfJob.applied_at = new Date();
            }
          });
        } else if (Perticularjob.apply_via == '1') {
          const dialogRef = this.dialog.open(ViaWorkNigeriaComponent, {
            height: '650px',
            width: '550px',
            data: { Perticularjob },
            autoFocus: false,
          });
          dialogRef.afterClosed().subscribe((res) => {
            if (res == 'save') {
              this.detailsOfJob.isApplied = true;
              this.detailsOfJob.applied_at = new Date();
            }
          });
        }
      }
    }
  }

  alreadyApply() {
    this.snackBar
      .openFromComponent(DynamicSnacbarSkipComponent, {
        data: 'You have Already Applied',
        verticalPosition: 'top',
        horizontalPosition: 'right',
      })
      .afterOpened()
      .subscribe(this.helper.setOnTop);
  }

  reportJob() {
    this.showReportSection = false;
    if (this.userDeatils?.id != undefined) {
      this.showReportSection = true;
    }
  }

  reportModel(Perticularjob: any) {
    const dialogRef = this.dialog.open(ReportJobComponent, {
      height: 'auto',
      width: '450px',
      data: { Perticularjob },
      autoFocus: false,
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res == 'save') {
        // Handle report
      }
    });
  }

  navigateToContactUs(title: any) {
    this.dataService.setData({ value: title, label: title });
    this.router.navigate(['/contactUs']);
  }

  redirectToInspireAfricaSignup() {
    window.open('https://inspireafricaconference.com', '_blank');
  }

  navigateToCvReview() {
    this.router.navigate(['/cv-review']);
  }

  clearJobDetails() {
    this.scrollToElement('topOfJobCards');
    this.detailsOfJob = null;
    this.showRightSectionInMobile = false;
    this.showDesc = false;
  }

  updateSearchParams() {}

  createAlert() {
    this.searchPhrase = this.jobFilter.get('searchText').value || '';

    if (this.userDeatils) {
      let jsonData = {
        path: this.email != null ? 'set-alert-visitor' : 'set-alert',
        alertName: this.searchPhrase,
        userId: this.email != null ? '' : this.userDeatils.id,
        keywords: this.searchPhrase,
        preferredLocation: '',
        categoryId: '',
        employmentTypeId: '',
        employmentType: '',
        jobCategory: '',
        minimumSalary: '',
        maximumSalary: '',
        emailFrequency: 'weekly',
        email: this.email,
      };

      if (this.email != null) {
        this.io._setAlertVisitor(jsonData).subscribe((res: any) => {
          if (res.serverResponse.code == 200) {
            this.snackBar.openFromComponent(DynamicSnacbarComponent, {
              data: res.serverResponse.message,
              verticalPosition: 'top',
              horizontalPosition: 'right',
            });
          }
        });
      } else {
        this.io._setAlert(jsonData).subscribe((res: any) => {
          if (res.serverResponse.code == 200) {
            this.snackBar.openFromComponent(DynamicSnacbarComponent, {
              data: res.serverResponse.message,
              verticalPosition: 'top',
              horizontalPosition: 'right',
            });
          }
        });
      }
    } else {
      // Save current state before redirecting to login
      this.saveFilterStateForLogin();

      this.router.navigate(['/login']);
      sessionStorage.setItem('setUrlRedirection', 'job-search');
      sessionStorage.setItem('searchTerm', this.searchPhrase);
    }
  }

  job_alert() {
    if (this.userDeatils) {
      if (this.userDeatils.userType == 'employer') {
        const dialogRef = this.dialog.open(
          RecruiterWantToJobSeekerSideComponent,
          {
            height: 'auto',
            width: '450px',
            data: {},
            autoFocus: false,
          }
        );
        dialogRef.afterClosed().subscribe((res) => {
          if (res == 'save') {
            // Handle save
          }
        });
      }
      if (this.userDeatils.userType == 'jobseeker') {
        this.router.navigate(['/job-alert']);
      }
    } else {
      // Save current state before redirecting to login
      this.saveFilterStateForLogin();

      this.router.navigate(['/login']);
      sessionStorage.setItem('setUrlRedirection', 'job-alert');
    }
  }

  ngOnDestroy() {
    this.titleService.setTitle('WorkNigeria');
    this.io.setforjobCategory(null);
  }

  postAjob() {
    if (this.userDeatils && this.userDeatils.userType == 'employer') {
      this.router.navigate(['/post-job']);
    } else {
      // Save current state before redirecting to login
      this.saveFilterStateForLogin();

      this.router.navigate(['/login']);
      sessionStorage.setItem('setUrlRedirection', 'post-job');
    }
  }

  // SEARCH FILTER FUNCTIONS
  get f() {
    return this.jobFilter.controls;
  }

  validationForm() {
    this.jobFilter = this.fb.group({
      created_at: [''],
      startDate: [''],
      endDate: [''],
      job_location: [''],
      employment_type_id: [''],
      company_name: [''],
      minimum_experience: [''],
      currency: [''],
      minimum_salary: [''],
      category_id: [''],
      jobs: [''],
      only_3mtt: [''],
      searchText: [''],
    });
  }

  start() {
    if (this.jobFilter.get('created_at').value == 'pastMonth') {
      let today = new Date(),
        format = 'yyyy-MM-dd';
      let priorDate: any = new Date().setDate(today.getDate() - 30);
      let value = priorDate;
      var datePipe = new DatePipe('en-US');
      value = datePipe.transform(priorDate, format);
      return value;
    } else if (this.jobFilter.get('created_at').value == 'pastweek') {
      let today = new Date(),
        format = 'yyyy-MM-dd';
      let priorDate: any = new Date().setDate(today.getDate() - 7);
      let value = priorDate;
      var datePipe = new DatePipe('en-US');
      value = datePipe.transform(priorDate, format);
      return value;
    } else if (this.jobFilter.get('created_at').value == 'past24hours') {
      let value = new Date().toDateString(),
        format = 'yyyy-MM-dd';
      var datePipe = new DatePipe('en-US');
      value = datePipe.transform(value, format);
      return value;
    } else {
      return '';
    }
  }

  end() {
    if (this.jobFilter.get('created_at').value == 'anyTime') {
      return '';
    } else {
      let value = new Date().toDateString(),
        format = 'yyyy-MM-dd';
      var datePipe = new DatePipe('en-US');
      value = datePipe.transform(value, format);
      return value;
    }
  }

  onFilterChange(event: any) {
    this.paginationService.setCurrentPage(1);
    this.searchByDipendency();
  }

  searchByDipendency() {
    if (this.totalNoJobs === 0) {
      setTimeout(() => {
        this.showLoading = false;
      }, 5000);
    }

    const searchTextControl = this.jobFilter.get('searchText');
    this.searchText2Way = this.jobFilter.get('searchText');
    searchTextControl?.setValidators([
      Validators.pattern(this.searchTextPattern),
    ]);
    searchTextControl?.updateValueAndValidity();

    this.displayFilters = false;

    if (this.userDeatils) {
      this.filtered = {
        path: 'search-job',
        userId: this.userDeatils.id,
        size: 10,
        start: 0,
      };
    } else {
      this.filtered = {
        path: 'search-job',
        size: 10,
        start: 0,
      };
    }

    if (this.location2Way != '') {
      this.filtered['job_location'] = this.location2Way;
    }

    this.count = 0;
    if (this.jobFilter.valid) {
      for (let key in this.jobFilter.value) {
        if (this.jobFilter.value[key]) {
          if (key != 'searchText' && key != 'job_location') {
            this.count = this.count + 1;
          }
          if (key == 'created_at' && this.jobFilter.value[key] != '') {
            this.filtered['endDate'] = this.end();
            this.filtered['startDate'] = this.start();
          } else {
            this.filtered[key] = this.jobFilter.value[key];
          }
        }
      }
    }

    // Update query params with current filters
    this.updateQueryParams(this.filtered);

    this.io.setforjobCategory(this.filtered);
  }

  resetFilters() {
    this.jobFilter.get('minimum_experience')?.setValue('');
    this.jobFilter.get('created_at')?.setValue('');
    this.jobFilter.get('category_id')?.setValue('');
    this.jobFilter.get('minimum_salary')?.setValue('');
    this.jobFilter.get('employment_type_id')?.setValue('');

    // Clear query params
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {},
      replaceUrl: true,
    });

    this.searchByDipendency();
  }

  employmentType() {
    this.io
      .apicall({ path: 'employment-type-list' }, 'job/employment-type-list')
      .subscribe((res: any) => {
        if (res.serverResponse.code == 200) {
          this.employemntTypeList = res['result'].employmentList;
        } else {
          this.snackBar
            .openFromComponent(DynamicSnacbarErrorComponent, {
              data: res.serverResponse.message,
              verticalPosition: 'top',
              horizontalPosition: 'right',
              duration: 6000,
            })
            .afterOpened()
            .subscribe(this.helper.setOnTop);
        }
      });
  }

  jobCatagory() {
    this.io
      .apicall({ path: 'category-list' }, 'job/category-list')
      .subscribe((res: any) => {
        if (res.serverResponse.code == 200) {
          this.jobCatagoryTypeList = res['result'].categoryList;
        } else {
          this.snackBar
            .openFromComponent(DynamicSnacbarErrorComponent, {
              data: res.serverResponse.message,
              verticalPosition: 'top',
              horizontalPosition: 'right',
              duration: 6000,
            })
            .afterOpened()
            .subscribe(this.helper.setOnTop);
        }
      });
  }

  detectMob() {
    const toMatch = [
      /Android/i,
      /webOS/i,
      /iPhone/i,
      /iPad/i,
      /iPod/i,
      /BlackBerry/i,
      /Windows Phone/i,
    ];

    return toMatch.some((toMatchItem) => {
      return navigator.userAgent.match(toMatchItem);
    });
  }

  copyLinkShare(job) {
    if (job.collectionname != undefined) {
      this.record = job.collectionname;
      this.jobLocation = job.job_location;
      this.title = 'Share this List with friends and family';
      this.detectMob();
      this.tinyUrl
        .shorten(
          `https://worknigeria.com/job-search?userId=${job.userId}&collectionId=${job.collectionId}`
        )
        .subscribe((res: any) => {
          this.url = res;
        });
    } else {
      this.pic = job.is_3mtt
        ? '../../../../assets/images/3mtt.svg'
        : (job.company_behalf_logo ?? job.logo);
      this.record = job.title;
      this.jobLocation = job.job_location;
      this.title = 'Share this job with friends and family';
      this.detectMob();
      this.tinyUrl
        .shorten(
          `https://worknigeria.com/job-search?id=${job.id}&title=${job.title}`
        )
        .subscribe((res) => {
          this.url = encodeURI(res);
        });
    }
    if (this.userDeatils) {
      this.email_title = `${this.userDeatils.firstName} thinks you may want to hear about this job!`;
    }
  }

  openSocialMedia(check) {
    if (check === 'linkedin') {
      window.open(
        `https://www.linkedin.com/sharing/share-offsite/?url=${this.url}`
      );
    } else if (check === 'facebook') {
      window.open(`https://www.facebook.com/sharer/sharer.php?u=${this.url}`);
    } else if (check === 'whatsapp') {
      window.open(`https://api.whatsapp.com/send?text=${this.url}`);
    }
  }

  copyUrl() {
    navigator.clipboard.writeText(this.url).then(
      () => {
        this.snackBar
          .openFromComponent(DynamicSnacbarComponent, {
            data: 'URL Copied to clipboard',
            verticalPosition: 'top',
            horizontalPosition: 'right',
          })
          .afterOpened()
          .subscribe(this.helper.setOnTop);
      },
      (error) => {
        this.snackBar
          .openFromComponent(DynamicSnacbarErrorComponent, {
            data: 'Something went wrong ',
            verticalPosition: 'top',
            horizontalPosition: 'right',
            duration: 6000,
          })
          .afterOpened()
          .subscribe(this.helper.setOnTop);
      }
    );
  }

  onKey(event) {
    const searchTextControl = this.jobFilter.get('searchText');
    searchTextControl?.setValidators([
      Validators.required,
      Validators.pattern(this.searchTextPattern),
    ]);
    searchTextControl?.updateValueAndValidity();
    const inputValue = event.target.value;
    this.paginationService.setCurrentPage(1);
  }

  joblocationName(e) {
    this.location2Way = e;
  }

  cityList() {
    let data = { path: 'city-list' };
    this.io._cityList(data).subscribe((res: any) => {
      if (res.serverResponse.code == 200) {
        this.cityRecords = res['result'].cityList.map((item) => item.state);
      }
    });
  }

  resetSearch(title: any) {
    this.showingTextResult = this.searchText2Way;
    this.searchText2Way = '';
    this.selectedInDemandJob = ''; // Add this line
    this.dataService.nextData(this.showingTextResult);
    const searchTextControl = this.jobFilter.get('searchText');
    searchTextControl?.setValidators([
      Validators.pattern(this.searchTextPattern),
    ]);
    searchTextControl?.updateValueAndValidity();
    this.jobFilter.controls['searchText'].reset();
    this.jobFilter.controls['job_location'].reset();

    // Clear search-related query params
    const currentParams = this.route.snapshot.queryParams;
    const newParams = { ...currentParams };
    delete newParams['searchText'];
    delete newParams['job_location'];

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: newParams,
      replaceUrl: true,
    });
  }
  onInDemandJobSelect(event: any) {
    const selectedJob = event.value;
    this.selectedInDemandJob = '';

    // Update the searchText control with the selected job
    this.jobFilter.patchValue({
      searchText: selectedJob,
    });

    // Update the 2-way bound variable
    this.searchText2Way = selectedJob;

    // Trigger the filter change
    this.onFilterChange(event);
  }
}
